/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {ReactNode, useEffect, useMemo, useRef, useState} from 'react'
import _ from 'lodash'
import {useTranslation} from 'react-i18next'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {twMerge} from 'tailwind-merge'
import {ReactComponent as IconPlanPro} from '../../assets/images/plan-pro.svg'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {ReactComponent as IconPlanBasic} from '../../assets/images/plan-basic.svg'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {ReactComponent as IconPlanEnterprise} from '../../assets/images/plan-enterprise.svg'
import {ReactComponent as IconPlanLabel} from '../../../assets/images/icon-plan-label.svg'
import AivatarClient from '../../../services/AivatarClient'
import PriceFormat from '../../Text/PriceFormater'
import {getPlanColor} from '../../../utils/colors'
import {useCurrentWorkspaceDetailQuery} from '../../../hooks/queries'
import CheckoutLink from './CheckoutLink'
import IconCheckGray from './IconCheckGray'
import ColumnHeader from './ColumnHeader'
import RowHeader from './RowHeader'
import Data from './Data'
import ContactLink from './ContactLink'
import {BasicPlanName, ProPlanName} from '../../../@types/common'
import {
    ANNUAL,
    MONTHLY,
    SubscriptionInterval,
    billingMonths,
    getAnnualDiscountPercent,
    getAnnualMonthlyPrice,
    getAnnualPrice,
} from '../../../services/payments/annual'

const FREE_VIDEO_MINUTE = 1

export default function SubscriptionPlanFeatureSheet({className = ''}) {
    const [plans, setPlans] = useState<any[]>([])
    const {data: currentWorkspace} = useCurrentWorkspaceDetailQuery()
    const {t} = useTranslation('plan-info-modal')
    const isPause = currentWorkspace?.subscription?.status === 'PAUSE'

    // 연간은 같은 플랜의 결제 방식 차이가 아니라 별도 요금 상품이라, 토글을 바꾸면
    // 모든 카드의 금액 표기가 함께 바뀐다 (기획 전달본 S1).
    const [billingInterval, setBillingInterval] = useState<SubscriptionInterval>(MONTHLY)
    const currentInterval = billingMonths(currentWorkspace?.subscription?.intervalMonth)
    const intervalInitialized = useRef(false)
    const discountPercent = getAnnualDiscountPercent(plans[0])

    const [selectedBasicPlanName, setSelectedBasicPlanName] = useState<BasicPlanName>('BASIC-1')
    const [selectedProPlanName, setSelectedProPlanName] = useState<ProPlanName>('PRO-1')

    // 토글은 현재 주기에서 시작한다. 연간 구독자에게 월간으로 열어두면 등급만 바꾸려던
    // 조작이 "연 → 월" 전환으로 나간다 (BE aivatar #357 T-D2). 워크스페이스는 비동기로
    // 도착하므로 첫 도착 때 한 번만 맞추고, 이후 refetch 가 사용자가 고른 토글을
    // 되돌리지 않게 막는다.
    useEffect(() => {
        if (!currentWorkspace || intervalInitialized.current) return
        intervalInitialized.current = true
        setBillingInterval(currentInterval)
    }, [currentWorkspace, currentInterval])

    useEffect(() => {
        if (currentWorkspace) {
            if (currentWorkspace?.subscription?.plan?.name?.startsWith('BASIC-')) {
                setSelectedBasicPlanName(currentWorkspace?.subscription?.plan?.name)
            }
            if (currentWorkspace?.subscription?.plan?.name?.startsWith('PRO-')) {
                setSelectedProPlanName(currentWorkspace?.subscription?.plan?.name)
            }
        }
    }, [currentWorkspace])

    const rows = useMemo<[string, ReactNode, ReactNode, ReactNode, ReactNode][]>(
        () => [
            // [
            //   '월 구독료',
            //   <span>
            //     <b>0원</b>
            //   </span>,
            //   <span>
            //     <b>{{ 'BASIC-1': '29,000', 'BASIC-2': '89,000' }[selectedBasicPlanName]}원</b>
            //     /월
            //   </span>,
            //   <span>
            //     <b>{{ 'PRO-1': '99,000', 'PRO-2': '290,000', 'PRO-3': '560,000' }[selectedProPlanName]}원</b>
            //     /월
            //   </span>,
            //   <div className="grid h-full w-full place-items-center bg-yellow-50">
            //     <b>{t('별도 문의',)}</b>
            //   </div>,
            // ],
            [
                t('크레딧'),
                <span>{t('{{credits}} 크레딧/1회', {credits: 600})}</span>,
                <div className="border-gs01-400 flex w-fit rounded-[500px] border p-[4px]">
                    <button
                        onClick={() => setSelectedBasicPlanName('BASIC-1')}
                        className={twMerge(
                            'text-gs01-400 grid h-[24px] place-items-center whitespace-nowrap px-[12px]',
                            selectedBasicPlanName === 'BASIC-1' && 'bg-bcblue-500 rounded-[50px] font-[500] text-white',
                        )}
                    >
            <span className="text-button02">
              1,800 {`${t('크레딧')}/${t('월', {ns: 'period', context: 'short'})}`}
            </span>
                    </button>
                    <button
                        onClick={() => setSelectedBasicPlanName('BASIC-2')}
                        className={twMerge(
                            'text-gs01-400 grid h-[24px] place-items-center whitespace-nowrap px-[12px]',
                            selectedBasicPlanName === 'BASIC-2' && 'bg-bcblue-500 rounded-[50px] font-[500] text-white',
                        )}
                    >
            <span className="text-button02">
              6,000 {`${t('크레딧')}/${t('월', {ns: 'period', context: 'short'})}`}
            </span>
                    </button>
                </div>,
                <div className="border-gs01-400 flex w-fit rounded-[500px] border p-[4px]">
                    <button
                        onClick={() => setSelectedProPlanName('PRO-1')}
                        className={twMerge(
                            'text-gs01-400 grid h-[24px] place-items-center whitespace-nowrap px-[12px]',
                            selectedProPlanName === 'PRO-1' && 'bg-bcblue-500 rounded-[50px] font-[500] text-white',
                        )}
                    >
            <span className="text-button02">
              6,000 {`${t('크레딧')}/${t('월', {ns: 'period', context: 'short'})}`}
            </span>
                    </button>
                    <button
                        onClick={() => setSelectedProPlanName('PRO-2')}
                        className={twMerge(
                            'text-gs01-400 grid h-[24px] place-items-center whitespace-nowrap px-[12px]',
                            selectedProPlanName === 'PRO-2' && 'bg-bcblue-500 rounded-[50px] font-[500] text-white',
                        )}
                    >
            <span className="text-button02">
              18,000 {`${t('크레딧')}/${t('월', {ns: 'period', context: 'short'})}`}
            </span>
                    </button>
                    <button
                        onClick={() => setSelectedProPlanName('PRO-3')}
                        className={twMerge(
                            'text-gs01-400 grid h-[24px] place-items-center whitespace-nowrap px-[12px]',
                            selectedProPlanName === 'PRO-3' && 'bg-bcblue-500 rounded-[50px] font-[500] text-white',
                        )}
                    >
            <span className="text-button02">
              36,000 {`${t('크레딧')}/${t('월', {ns: 'period', context: 'short'})}`}
            </span>
                    </button>
                </div>,
                <div className="grid h-full w-full place-items-center">
                    <span>{t('무제한 크레딧')}</span>
                </div>,
            ],
            [
                t('사용시간'),
                <>
                    <span>{t('영상 {{minutes}}분', {minutes: 1, count: 1})}</span>
                </>,
                <>
          <span>
            {
                {
                    'BASIC-1': t('영상 {{video_minutes}}분 또는 음성 {{audio_minutes}}분', {
                        video_minutes: 3,
                        audio_minutes: 30,
                    }),
                    'BASIC-2': t('영상 {{video_minutes}}분 또는 음성 {{audio_minutes}}분', {
                        video_minutes: 10,
                        audio_minutes: 100,
                    }),
                }[selectedBasicPlanName]
            }
          </span>
                </>,
                <>
          <span>
            {
                {
                    'PRO-1': t('영상 {{video_minutes}}분 또는 음성 {{audio_minutes}}분', {
                        video_minutes: 10,
                        audio_minutes: 100,
                    }),
                    'PRO-2': t('영상 {{video_minutes}}분 또는 음성 {{audio_minutes}}분', {
                        video_minutes: 30,
                        audio_minutes: 300,
                    }),
                    'PRO-3': t('영상 {{video_minutes}}분 또는 음성 {{audio_minutes}}분', {
                        video_minutes: 60,
                        audio_minutes: 600,
                    }),
                }[selectedProPlanName]
            }
          </span>
                </>,
                <div className="grid h-full w-full place-items-center">
                    <span>{t('무제한 영상 생성')}</span>
                </div>,
            ],
            [t('범용 아바타'), <>5</>, <>5</>, <>140</>, <>140+</>],
            [t('범용 아바타 제스처'), <>1</>, <>1</>, <span>{t('전체')}</span>, <span>{t('전체')}</span>],
            [
                t('셀프 커스텀 아바타'),
                <>-</>,
                <>
                    <span>{t('1개 슬롯')}</span>
                </>,
                <>
                    <span>{t('2개 슬롯')}</span>
                </>,
                <>
                    <span>{t('2개+ 슬롯')}</span>
                </>,
            ],
            [
                t('전속 아바타'),
                <>-</>,
                <>
                    <span>{t('별도 문의')}</span>
                </>,
                <>
                    <span>{t('별도 문의')}</span>
                </>,
                <>
                    <span>{t('별도 문의')}</span>
                </>,
            ],
            [
                t('AI 마스코트'),
                <>-</>,
                <>-</>,
                <>
                    <span>{t('별도 문의')}</span>
                </>,
                <>
                    <span>{t('별도 문의')}</span>
                </>,
            ],
            [
                t('스튜디오 커스텀 아바타'),
                <>-</>,
                <>-</>,
                <>
                    <span>{t('별도 문의')}</span>
                </>,
                <>
                    <span>{t('별도 문의')}</span>
                </>,
            ],
            [
                t('고급 AI 음성'),
                <>-</>,
                <>-</>,
                <>
                    <IconCheckGray/>
                </>,
                <>
                    <IconCheckGray/>
                </>,
            ],
            [
                t('커스텀 목소리'),
                <>-</>,
                <>
                    <span>{t('1개 슬롯')}</span>
                </>,
                <>
                    <span>{t('2개 슬롯')}</span>
                </>,
                <>
                    <span>{t('2개+ 슬롯')}</span>
                </>,
            ],
            [
                t('무제한 다운로드'),
                <>
                    <IconCheckGray/>
                </>,
                <>
                    <IconCheckGray/>
                </>,
                <>
                    <IconCheckGray/>
                </>,
                <>
                    <IconCheckGray/>
                </>,
            ],
            [
                t('워터마크 제거'),
                <>-</>,
                <>
                    <IconCheckGray/>
                </>,
                <>
                    <IconCheckGray/>
                </>,
                <>
                    <IconCheckGray/>
                </>,
            ],
            [
                t('팀 워크스페이스'),
                <>-</>,
                <>-</>,
                <>-</>,
                <>
                    <IconCheckGray/>
                </>,
            ],
            [
                t('맞춤형 고객지원'),
                <>-</>,
                <>-</>,
                <>
                    <IconCheckGray/>
                </>,
                <>
                    <IconCheckGray/>
                </>,
            ],
            [
                t('상업적 이용'),
                <>-</>,
                <>
                    <IconCheckGray/>
                </>,
                <>
                    <IconCheckGray/>
                </>,
                <>
                    <IconCheckGray/>
                </>,
            ],
        ],
        [selectedBasicPlanName, selectedProPlanName, t],
    )

    useEffect(() => {
        AivatarClient()
            .get('/plans')
            .then(({data}) => {
                setPlans(_.sortBy(data.content, 'level') as any)
            })
    }, [])

    const valuePrice = (amount: number) => {
        if (amount === 0) {
            return t('무료')
        }

        return <PriceFormat amount={amount} hideSuffix enablePrefix/>
    }

    return (
        <div className={className}>
            <div className="mb-[20px] flex justify-center">
                <div className="border-gs01-400 flex rounded-[500px] border p-[4px]">
                    <button
                        type="button"
                        onClick={() => setBillingInterval(MONTHLY)}
                        className={twMerge(
                            'text-gs01-400 grid h-[30px] place-items-center whitespace-nowrap px-[20px]',
                            billingInterval === MONTHLY && 'bg-bcblue-500 rounded-[50px] font-[500] text-white',
                        )}
                    >
                        <span className="text-button02">{t('월간')}</span>
                    </button>
                    <button
                        type="button"
                        onClick={() => setBillingInterval(ANNUAL)}
                        className={twMerge(
                            'text-gs01-400 grid h-[30px] place-items-center whitespace-nowrap px-[20px]',
                            billingInterval === ANNUAL && 'bg-bcblue-500 rounded-[50px] font-[500] text-white',
                        )}
                    >
            <span className="text-button02">
              {t('연간 · {{percent}}% 할인', {percent: discountPercent})}
            </span>
                    </button>
                </div>
            </div>
            <div className="bg-gray-7 relative overflow-hidden rounded-[20px] border border-[#A9BDEA] shadow">
            <table className="w-full">
                <colgroup>
                    <col/>
                    <col width="220"/>
                    <col width="220"/>
                    <col width="220"/>
                    <col width="220"/>
                </colgroup>
                <thead>
                <tr>
                    <ColumnHeader/>
                    {plans.map((plan, i) => {
                        if (plan.name.startsWith('BASIC-') && plan.name !== selectedBasicPlanName) return null
                        if (plan.name.startsWith('PRO-') && plan.name !== selectedProPlanName) return null

                        return (
                            <ColumnHeader key={plan.id}>
                                <div
                                    translate="no"
                                    className="mb-[10px] text-[22px] font-[900] text-[var(--color)]"
                                    // eslint-disable-next-line no-useless-computed-key
                                    style={{['--color' as any]: getPlanColor(plan.displayName)}}
                                >
                                    {plan.displayName}
                                </div>
                                <span className="mt-[6px] text-[20px] font-[900] text-[#3d3d3d]">
                    {plan.amount === 0 ? (
                        t('무료', {context: 'value'})
                    ) : billingInterval === ANNUAL ? (
                        <>
                            <PriceFormat amount={getAnnualMonthlyPrice(plan)} hideSuffix enablePrefix/>/
                            {t('월', {ns: 'period', context: 'short'})}
                        </>
                    ) : (
                        <>
                            <PriceFormat amount={plan.price} hideSuffix enablePrefix/>/
                            {t('월', {ns: 'period', context: 'short'})}
                        </>
                    )}
                  </span>
                                {billingInterval === ANNUAL && plan.amount !== 0 ? (
                                    <>
                                        {/* 월 환산가만 크게 두고 연 총액·1회 선결제 사실이 없으면 오인 소지가 있다 */}
                                        <span className="text-gray-21 mt-[4px] block text-center text-[11px] leading-[1.4]">
                        {t('연 {{amount}}원을 1회 결제 · 부가세 별도', {
                            amount: getAnnualPrice(plan).toLocaleString(),
                        })}
                      </span>
                                        <span
                                            className="text-bcblue-500 mt-[6px] inline-block rounded-[500px] bg-blue-100 px-[10px] py-[2px] text-[11px] font-[500]">
                        {t('월간 대비 {{percent}}% 할인', {percent: discountPercent})}
                      </span>
                                    </>
                                ) : null}
                                {/* {plan.name.startsWith('BASIC-') && (
                    <div className="border-gs01-400 flex rounded-[500px] border p-[4px]">
                      <button
                        onClick={() => setSelectedBasicPlanName('BASIC-1')}
                        className={twMerge(
                          'text-gs01-400 grid h-[24px] place-items-center whitespace-nowrap px-[12px]',
                          selectedBasicPlanName === 'BASIC-1' && 'bg-bcblue-500 rounded-[50px] font-[500] text-white',
                        )}
                      >
                        <span className="text-button02">1,800 크레딧</span>
                      </button>
                      <button
                        onClick={() => setSelectedBasicPlanName('BASIC-2')}
                        className={twMerge(
                          'text-gs01-400 grid h-[24px] place-items-center whitespace-nowrap px-[12px]',
                          selectedBasicPlanName === 'BASIC-2' && 'bg-bcblue-500 rounded-[50px] font-[500] text-white',
                        )}
                      >
                        <span className="text-button02">6,000 크레딧</span>
                      </button>
                    </div>
                  )}
                  {plan.name.startsWith('PRO-') && (
                    <div className="border-gs01-400 flex rounded-[500px] border p-[4px]">
                      <button
                        onClick={() => setSelectedProPlanName('PRO-1')}
                        className={twMerge(
                          'text-gs01-400 grid h-[24px] place-items-center whitespace-nowrap px-[12px]',
                          selectedProPlanName === 'PRO-1' && 'bg-bcblue-500 rounded-[50px] font-[500] text-white',
                        )}
                      >
                        <span className="text-button02">6,000 크레딧</span>
                      </button>
                      <button
                        onClick={() => setSelectedProPlanName('PRO-2')}
                        className={twMerge(
                          'text-gs01-400 grid h-[24px] place-items-center whitespace-nowrap px-[12px]',
                          selectedProPlanName === 'PRO-2' && 'bg-bcblue-500 rounded-[50px] font-[500] text-white',
                        )}
                      >
                        <span className="text-button02">18,000 크레딧</span>
                      </button>
                      <button
                        onClick={() => setSelectedProPlanName('PRO-3')}
                        className={twMerge(
                          'text-gs01-400 grid h-[24px] place-items-center whitespace-nowrap px-[12px]',
                          selectedProPlanName === 'PRO-3' && 'bg-bcblue-500 rounded-[50px] font-[500] text-white',
                        )}
                      >
                        <span className="text-button02">36,000 크레딧</span>
                      </button>
                    </div>
                  )} */}
                                <span className="mt-[18px]">
                    <CheckoutLink
                        // 같은 등급이라도 주기가 다르면 현재 플랜이 아니다.
                        // 월 PRO-1 이용 중에 연간 PRO-1 은 선택할 수 있어야 한다 (정책 11.5)
                        isCurrent={
                            !isPause &&
                            plan.id === currentWorkspace?.subscription?.plan?.id &&
                            billingInterval === currentInterval
                        }
                        planId={plan.id}
                        price={plan.price}
                        interval={billingInterval}
                    />
                  </span>
                                {plan.name.startsWith('PRO-') ?
                                    <IconPlanLabel className="absolute right-[10px] top-[-1px]"/> : null}
                            </ColumnHeader>
                        )
                    })}
                    <ColumnHeader key="enterprise">
                        <span className="text-main-1 mb-[10px] text-[22px] font-[900]">ENTERPRISE</span>
                        <span className="text-[20px] font-[900] text-[#3d3d3d]">{t('문의하기')}</span>
                        <span className="mt-[18px]">
                <ContactLink/>
              </span>
                    </ColumnHeader>
                </tr>
                </thead>
                <tbody>
                {rows.map((row) => (
                    <tr key={row[0]}>
                        <RowHeader>{row[0]}</RowHeader>
                        <Data>{row[1]}</Data>
                        <Data>{row[2]}</Data>
                        <Data>{row[3]}</Data>
                        <Data>{row[4]}</Data>
                    </tr>
                ))}
                </tbody>
            </table>
            </div>
        </div>
    )
}
